import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpLoaderComponent } from '../common-component/dp-loader/dp-loader.component';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { OblateDetailsService } from '../services/raintree/Transmission/oblate.service';
import {
  OblateDetails,
} from '../services/raintree/interfaces/oblate.interface';
import { StatusResolverService } from '../services/raintree/Transmission/status-resolver.service';
import { SerialNoCellComponent } from '../table-cell/serial-no-cell.component';
import { DpTableComponent } from '../common-component/dp-table/dp-table.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SearchService } from '../services/common/search.service';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { MatDialog } from '@angular/material/dialog';
import { AddNewOblatePopupComponent } from './add-new-oblate-popup/add-new-oblate-popup.component';
import { OblateFilterPopupComponent } from './oblate-filter-popup/oblate-filter-popup.component';
import { ToastrService } from 'ngx-toastr';
import { AppConfigService } from '../services/config/app-config.service';
import { PrintService } from '../services/common/print.service';
import { MasterSearchTransmissionService } from '../services/raintree/Transmission/master-search.service';
import { DpTabMenuV3Component } from '../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
import { Permissions } from '../enum/permission';
import { query } from 'express';
import { RequestMapper } from '../request-mapper';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AddOblateBottomSheetComponent } from './add-oblate-bottom-sheet/add-oblate-bottom-sheet.component';
import { RefreshedDateKey } from '../enum/refresh-date';

@Component({
  selector: 'app-oblate-data',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DpLoaderComponent,
    LoaderComponent,
    DpTableComponent,
    InfiniteScrollModule,
  ],
  providers: [DatePipe],
  templateUrl: './oblate-data.component.html',
  styleUrl: './oblate-data.component.scss',
})
export class OblateDataComponent implements OnInit {
  oblateDraftData: any;
  draftsAllowed: any;
  constructor(
    private oblateService: OblateDetailsService,
    private getStatusService: StatusResolverService,
    private _searchService: SearchService,
    private isMobile: CommonUtilService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private toaster: ToastrService,
    private appConfigService: AppConfigService,
    private printService: PrintService,
    private masterSearchService: MasterSearchTransmissionService,
    private _router: Router,
    private _bottomSheet: MatBottomSheet,
    private _oblate: OblateDetailsService,
  ) { }
  todayDate: any
  searchReq = new FormControl('');
  isLoading: boolean = false;
  allDataLoaded: boolean = false;
  isMobileDevice: boolean = false;
  isLoader: boolean = false;
  isAbleToAddDPOffline: boolean = false;
  isAbleToAddDPOnline: boolean = false;
  oblateData: OblateDetails[] = [];
  tempData: OblateDetails[] = [];
  pageNo: number = 1;
  pageSize: number = 100;
  detailsByDate: any[] = [];
  fromDate: any = '';
  toDate: any = '';
  stateName: any = ''
  districtName: any = ''
  pin: any = ''
  recStatus: any = ''
  memStatus: any = ''
  printedData: any = []
  permission: any = [];
  hasPrintAccess: boolean = false;
  statusMap: any;
  displayColumnData: any = [
    {
      id: 'mk',
      name: 'Sl.no',
    },
    {
      id: 'status',
      name: 'Status',
    },
    {
      id: 'fullName',
      name: 'Name',
    },
    {
      id: 'guardianName',
      name: 'Guardian',
    },
    {
      id: 'md',
      name: 'Initiation Date',
    },
    {
      id: 'mob',
      name: 'Contact',
    },
    {
      id: 'rn',
      name: 'Ritwik',
    },
    {
      id: 'pn',
      name: 'Pin',
    },
    {
      id: 'add',
      name: 'Adress',
    },
  ];
  showOnlineMessage!: boolean
  showOfflineMessage!: boolean
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  lastRefreshedDate: any
  
  ngOnInit(): void {
    const allPermissionV3: any = this.appConfigService.getAllPermissionsV3()
    const oblatePermission: any = allPermissionV3['Oblate Register']['default']['PERMISSION'];
    let oblateExistingPermissionArray: string[] = [];
    Object.keys(oblatePermission).forEach((country: any) => {
      const permissionState: string[] = Object.keys(oblatePermission[country]);
      permissionState.forEach((state: any) => {
        const permissionDistrict: string[] = Object.keys(
          oblatePermission[country][state]
        );
        permissionDistrict.forEach((district: any) => {
          oblatePermission[country][state][district].forEach((permission: string) => {
            oblateExistingPermissionArray.push(permission);
          })
        })
      })
    })

    this.isAbleToAddDPOffline = oblateExistingPermissionArray.includes('can_add_oblate_offline') ? true : false;
    this.isAbleToAddDPOnline = oblateExistingPermissionArray.includes('can_add_oblate_online') ? true : false;

    localStorage.setItem('oblate-present-route', RequestMapper.MY_OBLATES)
    this.pin = this.stateName = this.districtName = this.memStatus = this.recStatus = ''
    this.isLoading = true;
    this.masterSearchService.fetchLastRefreshDate().subscribe({
      next: (response: any) => {
        this.lastRefreshedDate = response.data.filter((item: any) => item.configName.includes('OBLATE_REGISTER'))
        this.lastRefreshedDate = this.datePipe.transform(this.lastRefreshedDate[0].date, 'MMM d, y')

      }, error: (error: any) => {
        console.log(error)
      }
    })
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.permission = this.appConfigService.fetchPermissionv3ByViewName();
    const permList = this.fetchPermission(this.permission)

    this.hasPrintAccess = permList.includes(Permissions.CanPrintDatum)

    // this.permission.forEach((item: { viewName: string; subview: any }) => {
    //   if (item.viewName == 'oblate_register_view') {
    //     if (item.subview[0].permission.includes('can_print_datum')) {
    //       this.hasPrintAccess = true;
    //     }
    //   }
    // });
    this.todayDate = this.datePipe.transform(new Date, 'dd/mm/yyyy')
    this.onCountClick();
    this.fetchWorkerActivity();
    this.getStatusAndOblateData();
    this.searchReq.valueChanges.subscribe((value: any) => {
      this.oblateData = this.tempData;
      if (value.length > 0) this.onSearch(value);
      else this.oblateData = this.tempData;
    });
     let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
        if (refreshDate) {
              this.draftsAllowed = refreshDate.filter((item: any) => item.configName.includes(RefreshedDateKey.oblateDraftsAllowed))
            }
  }
  fetchPermission(perm: any, finalPermList: any = []) {
    Object.values(perm).forEach((item: any) =>
      Array.isArray(item) ? finalPermList.push(...item) : typeof item === 'object' && this.fetchPermission(item, finalPermList)
    );
    return [...new Set(finalPermList)];
  }
  getStatusAndOblateData() {
    this.getStatusService.getStatusData().subscribe({
      next: (response) => {
        console.log("&&&");
        this.statusMap = new Map(
          response.data.map((item: { status_code: any; status_desc: any }) => [
            item.status_code,
            item.status_desc,
          ])
        );
        this.fetchOblate(true);
      },
      error: (error) => {
        this.toaster.error(error);
        this.isLoader = false;
      },
    })
  }
    getDraftList() {
    this._oblate.fetchOfflineDraftOblateList().subscribe({
      next: (response: any) => {
        if (!response.error) {
          // console.log(response.data)
          this.oblateDraftData = response.data.map((oblate: any) => ({
            ...oblate,
            fullName: [oblate.fName, oblate.mName, oblate.lName].filter(Boolean).join(" "),
            gfullName: [oblate.gfName, oblate.gmName, oblate.glName].filter(Boolean).join(" "),
            permAddress: [oblate.permAddress, oblate.permDistrict, oblate.permState, oblate.permPincode, oblate.permCountry].filter(Boolean).join(", "),
            presAddress: [oblate.presAddress, oblate.presDistrict, oblate.presState, oblate.presPincode, oblate.presCountry].filter(Boolean).join(", "),
          }));
          this.isLoader = false;
        }
      },
      error: (error: any) => {
        this.toaster.clear();
        this.toaster.error(error);
        this.isLoader = false;
      }
    })
  }

  onClickAddOblate(type: 'online' | 'offline') {
    if (type === 'online')
      this.oblateDraftData < this.draftsAllowed ? this._router.navigateByUrl(`/${RequestMapper.ADD_NEW_OBLATE_ONLINE}`) : this.toaster.error('Please clear your PENDING drafts to submit new Dikshya Patra')

    if (type === 'offline')
      this._router.navigateByUrl(`/${RequestMapper.LIST_DRAFT_OBLATE}`)
  }

  onClickAddOblateForMobile() {
    let addOblatePermission: string[] = []
    if (this.isAbleToAddDPOffline) {
      addOblatePermission.push('dpOffline')
    }

    if (this.isAbleToAddDPOnline) {
      addOblatePermission.push('dpOnline')
    }
    const addOblateBtmSheet = this._bottomSheet.open(AddOblateBottomSheetComponent, { data: addOblatePermission })

    addOblateBtmSheet.afterDismissed().subscribe((result) => {
      console.log(result)
      this.onClickAddOblate(result);
    })
  }

  fetchAllData() {
    this.isLoading = true
    this.oblateService.fetchOblateData({
      ...this.queryParams,
      pageNo: this.pageNo,
      pageSize: 200000,
      stateName: this.stateName,
      districtName: this.districtName
    }).subscribe({
      next: (response) => {
        if (response.data.length > 0) {
          this.printSelected(response.data.map(
            (item: any) => ({
              ...item,
              guardianName: item.gfn + ' ' + item.gln,
              fullName: item.fn + ' ' + item.ln,
            })
          ))
        }
        else
          this.toaster.error('No Data Found')
        this.isLoading = false
      },
      error: (error) => {
        this.toaster.error(error);
        this.isLoading = false;
      }
    }
    );
  }
  printSelected(data: any) {
    const header = 'OBLATE REGISTER';
    const columns = [
      'SL NO',
      'DIKSHYARTHI NAME',
      'RITWICK NAME',
      'GUARDIAN NAME',
      'INITIATION DATE',
      'PINCODE',
      'ADDRESS',
    ];
    const rows = data.map((user: any) => [
      user?.mk,
      user.fullName,
      user?.rn,
      user?.guardianName,
      user.md,
      user.pn,
      user.add,
    ]);
    const cellStyles: any = {
      0: { cellWidth: 2.0 },
      1: { cellWidth: 4.5 },
      2: { cellWidth: 5.0 },
      3: { cellWidth: 4.5 },
      4: { cellWidth: 3.0 },
      5: { cellWidth: 2.0 },
      6: { cellWidth: 7.5 },
    }
    this.printService.printPdf(rows, columns, header, 'Oblate_Register', 'l', 'a4', true, cellStyles);
  }

  fetchWorkerActivity() {
    this.isLoading = true;
    this.oblateService
      .fetchNoOfWorkingDays({ fromDate: this.fromDate, toDate: this.toDate })
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.countDetails = { ...this.countDetails, ...res.data[0] };
          // this.countDetails = {...res.data[0] };
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
  }
  queryParams: any
  fetchOblate(isStart?: boolean) {
    if (isStart) {
      this.isLoader = true;
      this.pageNo = 1;
    }
    this.queryParams = {
      ...this.queryParams, pageNo: this.pageNo,
      pageSize: this.pageSize,
      stateName: this.stateName,
      districtName: this.districtName,
    }
    this.oblateService.fetchOblateData(this.queryParams)
      .subscribe({
        next: (response) => {
          if (response.data.length > 0) {
            this.oblateData = response.data.map(
              (item: {
                rs: any;
                gfn: string;
                gln: string;
                fn: string;
                ln: string;
              }) => {
                if (this.statusMap.has(parseInt(item.rs))) {
                  return {
                    ...item,
                    status: this.statusMap.get(parseInt(item.rs)),
                    guardianName: item.gfn + ' ' + item.gln,
                    fullName: item.fn + ' ' + item.ln,
                  };
                }
                return item;
              }
            );
            console.log(this.oblateData);

            this.isLoader = false;
            if (this.tempData.length > 0 && this.pageNo > 1) {
              this.oblateData = [...this.tempData, ...this.oblateData];
            }
            this.tempData = this.oblateData;
          } else if (response.data.length === 0) {
            this.allDataLoaded = true;
            this.isLoader = false;
            // this.oblateData = this.tempData = []
          }
        },
        error: (error) => {
          this.toaster.error(error);
          this.isLoader = false;
        },
      });
  }
  onFilterClick() {
    const dialogRef = this.dialog.open(OblateFilterPopupComponent, {
      data: {
        fromDate: this.fromDate, toDate: this.toDate,
        state: this.stateName, district: this.districtName,
        pin: this.pin, recStatus: this.recStatus, memStatus: this.memStatus
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      this.queryParams = {}
      this.oblateData = [];
      this.tempData = [];
      this.pageNo = 1;
      // this.fromDate = value.fromDate;
      // this.toDate = value.toDate;
      this.stateName = value?.uiState
      this.districtName = value?.uiDistrict
      if (value?.pin.length === 6) {
        this.pin = value.pin
        this.queryParams = { ...this.queryParams, pinCode: value?.pin }
      } else
        this.pin = ''
      if (value?.memStatus) {
        this.memStatus = value?.memStatus
        this.queryParams = { ...this.queryParams, memStatus: value?.memStatus }
      } else
        this.memStatus = ''
      if (value?.recStatus) {
        this.recStatus = value?.recStatus
        this.queryParams = { ...this.queryParams, recStatus: value?.recStatus }
      } else
        this.recStatus = ''
      this.onCountClick();
      this.fetchOblate(true)
      this.fetchWorkerActivity();
    });
  }
  onAddNewClick() {
    const diaolgRef = this.dialog.open(AddNewOblatePopupComponent);
    // diaolgRef.afterClosed().subscribe((value) => {
    //   if (value) {
    //     this.fetchOblate();
    //   }
    // });
  }
  countDetails: any = {};
  onCountClick() {
    this.isLoading = true;
    this.oblateService
      .fetchOblateCount({
        fromDate: this.fromDate,
        toDate: this.toDate,
        pageNo: 1,
        pageSize: 500,
      })
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.countDetails = { ...this.countDetails, ...response.data };
        },
        error: (error) => {
          this.toaster.error(error);
        },
      });
  }
  onSearch(value: string) {
    this.oblateData = this._searchService.filterData(
      this.oblateData,
      value,
      this.displayColumnData
    );
  }
  // columnConfs = {
  //   status: { cssClass: 'memberStatuswidth' },
  //   pn: { cssClass: 'pincodewidth' },
  // };
  cellComponentMap = {
    mk: SerialNoCellComponent,
  };
  onScroll() {
    // const element = this.tableContainer.nativeElement;
    // const atBottom =
    //   element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
    // if (atBottom && !this.allDataLoaded) {
    this.pageNo += 1;
    this.fetchOblate();
    // }
  }
  ngAfterViewInit() {
    this.tableContainer?.nativeElement.addEventListener(
      'scroll',
      this.onScroll.bind(this)
    );
  }
  onSearchClick() { }
}
